import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["digit", "hidden"]

  connect() {
    const first = this.digitTargets.find(d => !d.value) || this.digitTargets[0]
    first?.focus()
  }

  onInput(event) {
    const input = event.target
    const digits = input.value.replace(/\D/g, "")

    if (digits.length > 1) {
      this.#distribute(digits)
      return
    }

    input.value = digits.slice(-1)
    this.#syncHidden()

    if (digits) this.#advance(input)
    this.#checkComplete()
  }

  onKeydown(event) {
    const input = event.target

    if (event.key === "Backspace" && !input.value) {
      this.#retreat(input)
    } else if (event.key === "ArrowLeft") {
      event.preventDefault()
      this.#retreat(input)
    } else if (event.key === "ArrowRight") {
      event.preventDefault()
      this.#advance(input)
    }
  }

  onPaste(event) {
    event.preventDefault()
    const text = event.clipboardData.getData("text").replace(/\D/g, "")
    this.#distribute(text)
  }

  onFocus(event) {
    event.target.select()
  }

  #distribute(digits) {
    this.digitTargets.forEach((input, i) => {
      input.value = digits[i] || ""
    })

    const next = this.digitTargets.find(d => !d.value) || this.digitTargets.at(-1)
    next.focus()

    this.#syncHidden()
    this.#checkComplete()
  }

  #advance(input) {
    const next = this.digitTargets[this.digitTargets.indexOf(input) + 1]
    next?.focus()
  }

  #retreat(input) {
    const prev = this.digitTargets[this.digitTargets.indexOf(input) - 1]
    if (prev) { prev.focus(); prev.select() }
  }

  #syncHidden() {
    this.hiddenTarget.value = this.digitTargets.map(d => d.value).join("")
  }

  #checkComplete() {
    if (this.digitTargets.every(d => /\d/.test(d.value))) {
      this.element.requestSubmit()
    }
  }
}
